import { environment } from '../../../environments/environment';
import { ProductModel } from './../models/product.model';
import { Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { ModelModel } from '../models/model.model';
import { ElementRef, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
declare const loadRebates: any;

@Component({
  selector: 'app-product-details-rebate',
  templateUrl: './product-details-rebate.component.html',
  styles: [
    `
    .eco-m .eco-c .panel {
      width: 840px !important;
    }
    .Amount-Div-Heading{
      font-family: LGEIRegular;
      font-size: 18px;
      color:white !important;
      padding-top:6px;
    }
    #ecorebates1 {
        padding-top: 10px;
        padding-bottom: 20px;
    }
#rebate-widget > ecr-product-widget > div:nth-child(1) > a{
    color:white !important;
}
    #rebate-widget {
      width: 100%;
      background-color:#a50034;
      margin-top: 10px;
    border-radius: 4px;
    }
    .open-details-container{
      background-color:#a50034;
    }
    #rebate-widget > ecr-product-widget > div:nth-child(1) > span{
      font-family: LGEIRegular;
      font-size: 18px;
      color:white !important;
      padding-top:6px;    
    }

    @media only screen and (max-width : 769px){
      .rebatesholder {
        text-align: center;
      }

    }
  `
  ]
})
export class ProductDetailsRebateComponent implements OnInit {
  @Input() model: any;

  sku: string[] = []; // Updated to hold multiple SKUs
  totalAmount: string;
  altRebateConsumerType: string;
  offerCount: string;

  constructor(private http: HttpClient,private renderer: Renderer2) { }

  ngOnInit(): void {
    // this.loadScript();
    // Extract query parameters from the hosting page URL
    const url = window.location.href;
    const urlObj = new URL(url);
    const queryParams = urlObj.searchParams;
    //const queryParams = this.route.snapshot.queryParams;
    const id = queryParams.get('productTypeId');
    const isCommercial = queryParams.get('iscommercial');
    const productClass = queryParams.get('class');
    //let skuData :string[] =[];
    //  const id = 'multi_v_water_5';
    //  const isCommercial = 'true';
    //  const productClass = 'Outdoor Units';
    const baseUrl= environment.baseUrl;
    if (id && isCommercial !== undefined && productClass) {
      const apiUrl = `${baseUrl}ProductSearch/${id}/ahrinumbers?iscommercial=${isCommercial}&productClass=${encodeURIComponent(productClass)}`;

      // Fetch SKU values from API
      this.http.get<string[]>(apiUrl).subscribe(
        (response: string[]) => {
          this.sku = response; // Assign the response array directly
          // this.sku.forEach((model) => {
          //   skuData.push(`${model}`);
          //   skuData.push(`${model}nonducted`);
          //   skuData.push(`${model}ducted`);
          //   skuData.push(`${model}mixed`);
          // });
          //  const widgetskuData = skuData.join(',');
          var rebateWidget = document.getElementById('rebate-widget'); // Debugging
          //rebateWidget.setAttribute('skus', this.sku.join(','));
          // Create the main custom element
          const productWidget = document.createElement("ecr-product-widget");
          // Create the first slot div
          const openDetailsDiv = document.createElement("div");
          openDetailsDiv.setAttribute("slot", "open-details");
          openDetailsDiv.setAttribute("style", "display:none;display:flex;flex-direction:column;text-align:center;margin-bottom:25px !important;");

          //Add heading for the first slot
          const amountDivHeader = document.createElement("span");
          amountDivHeader.innerHTML = "REBATES & OFFERS";
          amountDivHeader.setAttribute ("class","Amount-Div-Heading");
          amountDivHeader.setAttribute("style", "font-family: LGEIRegular;font-size: 18px;color:white !important;padding-top:6px;");

          openDetailsDiv.appendChild(amountDivHeader);
          const brTagone=document.createElement("br");
          amountDivHeader.appendChild(brTagone);

          // Add anchor tag to the first slot div
          const openDetailsAnchor = document.createElement("a");
          openDetailsAnchor.setAttribute("href", "#");
          openDetailsAnchor.setAttribute("style", "color:white;");
          openDetailsAnchor.innerHTML = "Up to {totalAmount} Available in {cityState}";
          openDetailsDiv.appendChild(openDetailsAnchor);

          // Create the second slot div
          const openDetailsNoAmountDiv = document.createElement("div");
          openDetailsNoAmountDiv.setAttribute("slot", "open-details-no-amount");
          openDetailsNoAmountDiv.setAttribute("style", "display:none;display:flex;flex-direction:column;text-align:center;margin-bottom:25px !important;");

          // Add heading for the second slot
          const notAmountDivHeader = document.createElement("span");
          notAmountDivHeader.innerHTML = "REBATES & OFFERS";
          notAmountDivHeader.setAttribute("class","Amount-Div-Heading");
          openDetailsNoAmountDiv.appendChild(notAmountDivHeader);
          notAmountDivHeader.setAttribute("style", "font-family: LGEIRegular;font-size: 18px;color:white !important;padding-top:6px;");
          const brTagsecond=document.createElement("br");
          notAmountDivHeader.appendChild(brTagsecond);
          // Add anchor tag to the second slot div
          const openDetailsNoAmountAnchor = document.createElement("a");
          openDetailsNoAmountAnchor.setAttribute("href", "#");
          openDetailsNoAmountAnchor.innerHTML = "{offerCount} {altRebateConsumerType} Rebate{s} available";
          openDetailsNoAmountDiv.appendChild(openDetailsNoAmountAnchor);

          // Append the slot divs to the main widget
          productWidget.appendChild(openDetailsDiv);
          productWidget.appendChild(openDetailsNoAmountDiv);
          productWidget.setAttribute("skus", this.sku.join(','));
          // Append the product widget to the body (or another desired element)
          var rebateWidgetCheck = document.getElementsByTagName('ecr-product-widget');
          if (rebateWidgetCheck.length == 0) {
            rebateWidget.appendChild(productWidget);
          }
        },
        (error) => {
          console.error('Error fetching SKUs:', error);
        }
      );
    } else {
      console.warn('Missing required query parameters in URL');
    }
  }

  loadScript() {
    // Create a script element
    const script = this.renderer.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src =
      (window.location.protocol === "https:" ? "https://" : "http://") +
      "static.ecorebates.com/widgets/lghvac/product.js";

    const head = document.getElementsByTagName("head")[0];
    this.renderer.appendChild(head, script);
  }
}



// WEBPACK FOOTER //
// ./src/app/product-category/components/product-details-rebate.component.ts